import * as React from 'react';
import { useState } from 'react';

type ExpandableTextProps = {
    text: string;
    maxLength?: number;
};

const Expand: React.FC<ExpandableTextProps> = ({ text, maxLength = 30 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div>
            {isExpanded ? (
                <span>{text}</span>
            ) : (
                <span aria-hidden={!isExpanded}>
                    {text.slice(0, maxLength)}
                    {text.length > maxLength && '...'}
                </span>
            )}
            {text.length > maxLength && (
                <button
                    onClick={toggleExpanded}
                    className="o-expand-button"
                    aria-expanded={isExpanded}
                    style={{
                        marginLeft: '5px',
                    }}
                >
                    {isExpanded ? 'Vis mindre' : 'Vis mer'}
                </button>
            )}
        </div>
    );
};

export default Expand;
